<!-- DatabaseItem.svelte (Drop-in replacement) -->
<script>
    import IconPeople from "./icons/IconPeople.svelte";
    import IconAccessibility from "./icons/IconAccessibility.svelte";
    import BootstrapCard from "./BootstrapCard.svelte";
    import LinkList from "./LinkList.svelte";
    import IconLink from "./icons/IconLink.svelte";
    import DatabaseItemFooter from "./DatabaseItemFooter.svelte";
    import VideoList from "./VideoList.svelte";

    /* --------------- GA Tracking Import --------------- */
    import { sendGAEvent } from "../utilities/ga.js";

    export let database;

    /**
     * If the database is flagged as "enabled", proxy through libproxy.
     * Otherwise, just return the original URL.
     */
    function proxyUrl(url) {
        const proxyEnabled = database.disable_proxy === "enabled";
        return proxyEnabled ? `https://libproxy.pcc.edu/login?url=${url}` : url;
    }

    /**
     * Handles clicks on the main outbound link.
     * Because it's target="_blank", we don't need preventDefault()
     * to avoid the page unloading.
     */
    function handleOutboundLinkClick() {
        sendGAEvent(
            "AllDatabases",            // event_category
            "outbound_link",           // eventAction (GA4 event name)
            database.title,            // event_label (could also use database.database_url)
            window.location.pathname   // or router.location.path, if desired
        );
    }
</script>

<BootstrapCard classes="bg-white mb-4">
    <span slot="header" class="bg-transparent">
       <!-- Attach on:click to track in GA4 -->
       <a
               href={proxyUrl(database.database_url)}
               target="_blank"
               rel="noreferrer"
               tabindex="0"
               on:click={handleOutboundLinkClick}
       >
         {@html database.title}
       </a>
    </span>

    <span slot="title"></span>

    <span slot="content" class="row">
        <div class="col">
            <p>{@html database.description}</p>
        </div>

        {#if database.tutorials.some(link => link.title && link.url)
        || database.handouts.some(link => link.title && link.url)
        || (database.linking_videos)
        }
            <div class="col-12 col-lg-5 pt-lg-0">
                <LinkList links="{database.tutorials}" title="Tutorials" />

                {#if database.handouts.some(link => link.title && link.url)}
                    <LinkList links="{database.handouts}" title="Handouts" />
                {/if}

                {#if database.linking_videos && database.linking_videos.length > 0
                && database.linking_videos[0].video
                }
                    <VideoList videos={database.linking_videos} title="Videos" />
                {/if}
            </div>
        {/if}

        <div class="col-12">
            {#if database.peer === 'true'}
                <span class="tag text-gray">
                    <IconPeople
                            width="1rem"
                            height="1rem"
                            padding="--padding-form"
                            fill="--color-gray" />
                    &nbsp;Peer-reviewed content
                </span>
            {/if}
        </div>
    </span>

    <span slot="footer">
       <DatabaseItemFooter {database} on:click />
    </span>
</BootstrapCard>

<style>
    /* No changes to styling or layout */
</style>
